import AGSAnimateBehaviour from "ags/behaviours/ags-animate-behaviour";

export class AGSAlternateAnimateBehaviour extends AGSAnimateBehaviour {

    protected startAnimation() {
        this.animation.gotoAndPlay(Math.floor(this.animation.totalFrames * 0.25));
    }
}
